import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import LayoutLogin from './LayoutLogin';
import LayoutMain from './LayoutMain';
import LayoutTraining from './LayoutTraining';
import ResetPassword from './ResetPassword';
import { AuthorizationStatus } from './store/login'
import { getLocalStorageValue, setLocalStorageValue, removeLocalStorageValue } from './store/localstorage'
import { loadCapture, clearCapture } from './workoutCapture'

const PLAYER_SESSION_KEY = 'trainer/playerSession'

function App() {

  const login = useSelector(state => state.login);
  const [ playerSession, setPlayerSession ] = useState(() => getLocalStorageValue(PLAYER_SESSION_KEY, null));
  const [ pendingExists, setPendingExists ] = useState(() => Boolean(loadCapture()));

  const enterTraining = (workout, ftp) => {
    const session = { workout, ftp }
    setPlayerSession(session)
    setLocalStorageValue(PLAYER_SESSION_KEY, session)
  }

  const exitTraining = () => {
    setPlayerSession(null)
    removeLocalStorageValue(PLAYER_SESSION_KEY)
    clearCapture()
    setPendingExists(false)
  }

  // A password-reset deep link arrives as a hash route (the SPA has no path
  // router); it must render above the session gates because the user may not
  // be logged in at all, and a logged-in user clicking the link holds a JWT
  // that is already stale server-side.
  const resetMatch = /^#\/reset-password\?token=(.+)$/.exec(window.location.hash)
  if (resetMatch)
    return <ResetPassword token={decodeURIComponent(resetMatch[1])} />

  if (playerSession || pendingExists) {
    const capture = playerSession ? null : loadCapture()
    return (
      <LayoutTraining
        workout={playerSession ? playerSession.workout : capture.workout}
        ftp={playerSession ? playerSession.ftp : capture.ftp}
        onNormalMode={exitTraining}
      />
    )
  }

  if (login.status === AuthorizationStatus.authorized)
    return (<LayoutMain onStartWorkout={enterTraining} />)
  else
    return (<LayoutLogin />)

}

export default App;